import { Component } from 'react';
import Menu from "../Menu";

class MenuNL extends Component {
  render() {
    return (
        
        <Menu 
           language="/nl"
           switches={[
               { url: this.props.switchUrlFR, name: "FR" },
               { url: this.props.switchUrlEN, name: "EN" }
           ]}
           menus={[
                { url:"/nl", name:"Home" },
                { url:"#", name:"Ons team", 
                    children:[
                      { name:"Frank Coel", url: "/nl/frank-coel"},
                      { name:"Anna Mamchenkova", url: "/nl/anna-mamchenkova"},
                    ] 
                },
                { url:"#", name:"Onze diensten", 
                  children:[
                    { name:"Bedrijf met moeilijkheden", url: "/nl/bedrijven-in-moeilijkheden"},
                    { name:"Advies, verdediging en geschillen", url: "/nl/advies-verdediging-geschillen"},
                  ] 
                },
                { url:"/nl/publicaties", name:"Publicaties" },
                { url:"/nl/pers", name:"Pers" },
                { url:"/nl/contact", name:"Contact" }
            ]}
           
        />
        
    );
  }
}

export default MenuNL
